/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ProfilePostWithUserListResponse } from '../models/profile-post-with-user-list-response';
import { PromoResponseList } from '../models/promo-response-list';
import { promosAdultGet } from '../fn/promo-resource/promos-adult-get';
import { PromosAdultGet$Params } from '../fn/promo-resource/promos-adult-get';
import { promosGet } from '../fn/promo-resource/promos-get';
import { PromosGet$Params } from '../fn/promo-resource/promos-get';
import { promosSafeGet } from '../fn/promo-resource/promos-safe-get';
import { PromosSafeGet$Params } from '../fn/promo-resource/promos-safe-get';
import { promosWeeklyGet } from '../fn/promo-resource/promos-weekly-get';
import { PromosWeeklyGet$Params } from '../fn/promo-resource/promos-weekly-get';

@Injectable({ providedIn: 'root' })
export class PromoResourceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `promosGet()` */
  static readonly PromosGetPath = '/promos';

  /**
   * Get All Promos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosGet$Response(
    params: PromosGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromoResponseList>> {
    const obs = promosGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get All Promos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosGet(
    params: PromosGet$Params,
    context?: HttpContext,
  ): Observable<PromoResponseList> {
    const resp = this.promosGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<PromoResponseList>): PromoResponseList => r.body,
      ),
    );
  }

  /** Path part for operation `promosAdultGet()` */
  static readonly PromosAdultGetPath = '/promos/adult';

  /**
   * Get All Promos Adult.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promosAdultGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosAdultGet$Response(
    params: PromosAdultGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromoResponseList>> {
    const obs = promosAdultGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get All Promos Adult.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promosAdultGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosAdultGet(
    params: PromosAdultGet$Params,
    context?: HttpContext,
  ): Observable<PromoResponseList> {
    const resp = this.promosAdultGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<PromoResponseList>): PromoResponseList => r.body,
      ),
    );
  }

  /** Path part for operation `promosSafeGet()` */
  static readonly PromosSafeGetPath = '/promos/safe';

  /**
   * Get All Promos Safe.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promosSafeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosSafeGet$Response(
    params: PromosSafeGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromoResponseList>> {
    const obs = promosSafeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get All Promos Safe.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promosSafeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosSafeGet(
    params: PromosSafeGet$Params,
    context?: HttpContext,
  ): Observable<PromoResponseList> {
    const resp = this.promosSafeGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<PromoResponseList>): PromoResponseList => r.body,
      ),
    );
  }

  /** Path part for operation `promosWeeklyGet()` */
  static readonly PromosWeeklyGetPath = '/promos/weekly';

  /**
   * Get Weekly Top Post.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promosWeeklyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosWeeklyGet$Response(
    params?: PromosWeeklyGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ProfilePostWithUserListResponse>> {
    const obs = promosWeeklyGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Weekly Top Post.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promosWeeklyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promosWeeklyGet(
    params?: PromosWeeklyGet$Params,
    context?: HttpContext,
  ): Observable<ProfilePostWithUserListResponse> {
    const resp = this.promosWeeklyGet$Response(params, context);
    return resp.pipe(
      map(
        (
          r: StrictHttpResponse<ProfilePostWithUserListResponse>,
        ): ProfilePostWithUserListResponse => r.body,
      ),
    );
  }
}
